exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-border-box-5{position:relative;width:100%;height:100%}.dv-border-box-5 .dv-reverse{transform:rotate(180deg)}.dv-border-box-5 .dv-border-svg-container{position:absolute;top:0;left:0;width:100%;height:100%}.dv-border-box-5 .dv-border-svg-container>polyline{fill:none}.dv-border-box-5 .dv-bb5-line-1,.dv-border-box-5 .dv-bb5-line-2{stroke-width:1}.dv-border-box-5 .dv-bb5-line-3,.dv-border-box-5 .dv-bb5-line-6{stroke-width:5}.dv-border-box-5 .dv-bb5-line-4,.dv-border-box-5 .dv-bb5-line-5{stroke-width:2}.dv-border-box-5 .border-box-content{position:relative;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/borderBox5/src/main.css
// module id = 1076
// module chunks = 45